import { getOSType } from './getOSType';

export const isAndroid = getOSType() === 'Android';
